import * as React from 'react';
import classnames from 'classnames';

import { renderPrice } from 'utils/helper/price';

import './campaign-overview-group.scss';

type Props = {
  budget: number,
  title: string,
  className?: string
};

const CampaignOverviewGroup = ({
  budget,
  title,
  className
}: Props) => (
  <div
    className={classnames('campaign-overview-group', {
      [`${className}`]: Boolean(className)
    })}
  >
    <div className="campaign-overview-group__budget">
      {renderPrice(budget)}
    </div>
    <div className="campaign-overview-group__title">
      {title}
    </div>
  </div>
);

export default CampaignOverviewGroup;
